import API from './api';

export function doLogin(username, password, onSuccess, onError) {
  API.post(`login`, {
    username: username,
    password: password
  })
  .then(res => {
    if(res.status !== 200) {
      throw new Error(res.data)
    }
    return res.data;
  }).then(function (data) {
    onSuccess(data);
  }).catch(function (error) {
    if(error.response) {
      onError(error.response.data);
    } else {
      onError({
        message: "Couldn't connect to the API"
      });
    }
  });
}

export function doUpdateLicenseKey(key, onSuccess, onError) {
  API.post(`licensekey`, {
    key
  })
  .then(res => {
    if(res.status !== 200) {
      throw new Error(res.data)
    }
    return res.data;
  }).then(function (data) {
    onSuccess(data);
  }).catch(function (error) {
    onError(error.response.data);
  });
}


export function doAuth(onSuccess, onError) {

}

export function doRefreshToken(onSuccess, onError) {

}
